import { PermissionLabels } from 'constants/permissions';

export const permissions: { [permission: string]: PermissionLabels[] } = {
  addAccount: ['add_account'],
  editAccount: ['change_account'],
  deleteAccount: ['delete_account'],
};
